import { client } from "./client";

export const createReservation = async (eventId) => {
    const response = await client.post(`/api/events/${eventId}/reservations/`, {});
    return response.data;
};

export const cancelReservation = async (reservationId) => {
    const response = await client.delete(`/api/reservations/${reservationId}/`);
    return response.data;
};

export const checkInEvent = async (eventId) => {
    const response = await client.post(`/api/events/${eventId}/check-in/`);
    return response.data;
};
